<template>
  <div>
    <el-card>
      <template #header>
        <h4>{{$t('一级食材')}}</h4>
      </template>

      <el-form>
        <el-form-item :label="`${$t('名称')}：`">
          <span>{{ detailInfo.treeName || "" }}</span>
        </el-form-item>
        <el-form-item :label="`${$t('图片')}：`">
          <preview-img :size="80" :img-url="detailInfo.photo" />
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mt16">
      <template #header>
        <h4>{{$t('二级食材')}}</h4>
      </template>

      <el-form inline size="small">
        <el-form-item :label="$t('名称')">
          <el-input :placeholder="$t('名称')" v-model="searchForm.name"/>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
          <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
        </el-form-item>
      </el-form>

      <div class="btn-row">
        <el-button type="danger" size="small" @click="handleBatchDelete">{{$t('删除')}}</el-button>
        <el-button type="primary" size="small" @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
<!--        <el-button size="small" @click.native="$refs.treeTable.handleChangeExpandState()">{{ expandState ? "收起" : "展开" }}</el-button>-->
      </div>


      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  :height="600"
                  :expand.sync="expandState"
                  ref="treeTable"
                  :row-template="rowTemplate">
        <template #photo="{row}">
          <pic-upload
              :limit="1"
              width="80px"
              height="80px"
              v-model="row.photo"
              :download-url="$api.file.downloadImg"
              :action="$api.file.upload"/>
        </template>

        <template #isAdd="{row}">
          <div>
            <el-link
                type="primary"
                :underline="false"
                v-if="!row.sub.length"
                @click="handleGoElDetail(row)">{{ row.isAdd == "yes" ? $t('已添加') : $t('添加') }}
            </el-link>
          </div>
        </template>

        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            <el-link type="primary" :underline="false" @click="handleCheckOrAddEl(row)">{{$t('查看')}}</el-link>
          </div>
        </template>
      </tree-table>
    </el-card>
  </div>
</template>

<script>
import {request} from "@/config/request";
import PicUpload from "@/components/pic-upload/PicUpload";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import {resetEmpty} from "@/utils/common";

export default {
  name: "FoodDetail",
  components: {TreeTable, PreviewImg, PicUpload},
  data() {
    return {
      searchForm: {},
      tableData: [],

      // 新增row 需要的字段数据
      rowTemplate: {
        code: "",
        name: "",
        expand: "yes",
        photo: "",
        isAdd: "no",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      },

      columnList: [
        {label: "食材名称", prop: "name", type: "input", minWidth: "400", fixed: "left"},
        {label: "图片", prop: "photo", minWidth: "200"},
        {label: "移动", prop: "", type: "more", minWidth: "200"},
        {label: "微量元素", prop: "isAdd", minWidth: "100"},
        // {label: "默认展开", prop: "expand", type: "switch"},
        {label: "创建时间", prop: "createTimeStr", minWidth: "200"},
        {label: "操作", prop: "operate", minWidth: "100"},
      ],


      expandState: true,

      detailInfo: {}
    }
  },
  methods: {
    resetEmpty,
    // 元素详情
    handleGoElDetail(row) {
      if (row.isNewAdd) {
        this.$message.warning(this.$t('请先保存'));
        return;
      }
      this.$router.push('/food/addEl?code=' + row.code);
    },

    // 查看二级或添加元素
    handleCheckOrAddEl(row) {
      if(row.sub.length) {
        this.$router.push(`/food/detail/${row.code}`)
      } else {
        this.$router.push({
          path: "/food/addEl",
          query: {
            code: row.code,
          }
        })
      }
    },

    // 保存
    async handleSaveSubmit() {
      try {
        const foodSortBeans = this.handleBuildParams(this.tableData);
        const params = {
          foodSortBeans,
          parentCode: this.$route.params.code,
        }
        await request(this.$api.foodSort.saveSecond, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      } catch (e) {
        console.log(e);
      }
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if (item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          photo: item.photo,
          sub,
        }
      })
    },

    // 加载子级列表
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          parentTree: this.$route.params.code,
          onPage: false,
        }
        const res = await request(this.$api.foodSort.listSecond, params);
        this.tableData  = handleBuildTreeData(res.foodSorts, item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.foodSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.foodSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);
      } catch (e) {
        console.error(e);
      }
    },

    async handleLoadDetail() {
      try {
        const res = await request(this.$api.foodSort.detail, this.$route.params);
        this.detailInfo = res.foodSort;
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    "$route.params.code": {
      handler() {
        this.$nextTick(() => {
          this.handleLoadDetail();
          this.handleSearch();
        })
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

.cover {
  border-radius: 12px;
  width: 100px;
  height: 100px;
}

/deep/ .cell {
  display: flex;
  align-items: center;
}


.btn-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px;
  margin-bottom: 16px;
}

</style>
